import recurringOptions from '../options/recurringOptions';

export default {
  recurring_type: {
    value: '',
    error: null,
    name: 'recurring_type',
    placeholder: 'Select Auto Campaign Type',
    breed: 'select',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
    options: recurringOptions,
    displayValue: '',
    isActive: false
  }
}



/** WEBPACK FOOTER **
 ** ./src/forms/autoCampaign/autoCampaignPhase1.js
 **/